import {IEntryForShow} from '../_interface/ientry-for-show';
import {ListSortEnum} from '../_interface/list-sort.enum';

export const sortEntriesList = (list: IEntryForShow[], sortBy: ListSortEnum, direction: -1 | 1): IEntryForShow[] => {
	switch (sortBy) {
		case ListSortEnum.date:
			return [...list].sort((a: IEntryForShow, b: IEntryForShow) =>
				a.entryChangeDate > b.entryChangeDate ? direction : -direction);
		case ListSortEnum.fields:
			return [...list].sort((a: IEntryForShow, b: IEntryForShow) =>
				a.fields.length > b.fields.length ? direction : -direction);
		case ListSortEnum.author:
			return [...list].sort((a: IEntryForShow, b: IEntryForShow) =>
				a.author.name > b.author.name ? direction : -direction);
		case ListSortEnum.type:
			return [...list].sort((a: IEntryForShow, b: IEntryForShow) =>
				a.entryType.entryType > b.entryType.entryType ? direction : -direction);
		default:
			return list;
	}
};
